import { useMemo } from 'react';

import { InfoField, ChipLinkBox, StoreMallDirectoryOutlinedIcon } from '@occc-app/design-system';
import { LocationFragment } from '@occc/graphql';
import { routeCreator } from '@occc-app/routes/Location/utils';

type LocationsInfoFieldProps = {
  label?: string;
  locations: LocationFragment[];
};

export const LocationsInfoField = ({ label, locations }: LocationsInfoFieldProps) => {
  const chipItems = useMemo(() => {
    if (!locations) {
      return null;
    }

    return locations.map((location) => {
      return {
        label: location?.siteSystemConfiguration[0]?.identifier ?? location.uuid,
        href: routeCreator.generalDetails(location.uuid),
      };
    });
  }, [locations]);

  if (!chipItems || chipItems.length === 0) {
    return null;
  }

  return (
    <InfoField
      label={label ?? 'Locations'}
      value={<ChipLinkBox items={chipItems} chipIcon={StoreMallDirectoryOutlinedIcon} />}
      disableTypography
    />
  );
};
